export default class MissingConfigurationValueError extends Error {
};
